import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Pill } from '@bibliocommons/pill';
import { UserCircle } from '@bibliocommons/base-icons';
import { userIdentityShape, ugcTagShape } from '@bibliocommons/bc-prop-types';
import { TAG_TYPES } from '../../../../constants/TagsConstants';
import DisplayWrapper from '../DisplayWrapper';
import './TagDisplay.scss';

export default class TagDisplay extends React.PureComponent {
  renderTagPill() {
    const { tag, owner, handleClick, tagsActions } = this.props;
    const tagId = tag.get('id');
    const tagValue = tag.get('value');
    const tagType = tag.get('type');
    const metadataId = tag.get('metadataId');
    const renderIcon = () => (tagType === TAG_TYPES.PERSONAL ? <UserCircle /> : null);
    const handleRemove =
      tagId && owner.get('loggedIn') ? () => tagsActions.removeTag(metadataId, tagId, tagType) : undefined;

    return (
      <Pill icon={renderIcon()} onClick={handleClick} handleDismiss={handleRemove}>
        {tagValue}
      </Pill>
    );
  }

  render() {
    return <DisplayWrapper className="cp-ugc-tag-display">{this.renderTagPill()}</DisplayWrapper>;
  }
}

TagDisplay.propTypes = {
  handleClick: PropTypes.func,
  tag: PropTypes.oneOfType([
    ugcTagShape,
    ImmutablePropTypes.contains({
      id: PropTypes.number.isRequired,
      metadataId: PropTypes.string.isRequired,
      type: PropTypes.oneOf(
        Immutable.Map(TAG_TYPES)
          .valueSeq()
          .toArray()
      ).isRequired,
      value: PropTypes.string.isRequired
    })
  ]).isRequired,
  owner: userIdentityShape.isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired
};
